import { ethers } from "ethers";
import { USDT_DECIMALS } from "../config/contract";

// Format a BigNumber (USDT, 18 decimals) -> human string with up to `dp` decimals.
export function fmtUsdt(value, dp = 2) {
  try {
    if (value == null) return "0";
    const s = ethers.utils.formatUnits(value, USDT_DECIMALS);
    const n = parseFloat(s);
    if (Number.isNaN(n)) return "0";
    return n.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: dp,
    });
  } catch {
    return "0";
  }
}

// Raw float value (for animated counters)
export function toNumber(value) {
  try {
    return parseFloat(ethers.utils.formatUnits(value, USDT_DECIMALS));
  } catch {
    return 0;
  }
}

// Parse a human amount -> BigNumber (USDT, 18 decimals)
export function parseUsdt(amount) {
  return ethers.utils.parseUnits(String(amount), USDT_DECIMALS);
}

export function shortAddr(addr) {
  if (!addr) return "";
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function fmtNumber(n) {
  const num = typeof n === "object" && n.toNumber ? n.toNumber() : Number(n);
  return num.toLocaleString();
}

// Board lifecycle state for color coding.
//   locked (grey) | live (green) | warn (orange, >=80% ceiling) | full (red, ceiling hit)
export function boardState(det) {
  if (!det || !det.isActive) return "locked";
  const earned = toNumber(det.totalEarned);
  const cap = toNumber(det.ceilingLimit);
  const remaining = toNumber(det.remainingLimit);
  if (cap > 0 && remaining <= 0) return "full";
  const pct = cap > 0 ? (earned / cap) * 100 : 0;
  if (pct >= 80) return "warn";
  return "live";
}

export function boardPct(det) {
  if (!det || !det.isActive) return 0;
  const earned = toNumber(det.totalEarned);
  const cap = toNumber(det.ceilingLimit);
  if (cap <= 0) return 0;
  return Math.min(100, (earned / cap) * 100);
}
